import Banner from "Components/Banner";
import RJCBanner from "Components/RJCBanner";
import OurDiamondCuts from "Components/OurDiamondCuts";
// import AboutSection from "Components/AboutSection";
// import WhyChooseArjiv from "Components/WhyChooseArjiv";
import LayoutAndMatchPair from "Components/LayoutAndMatchPair";
import Quote from "Components/Quote";
import Customization from "Components/Customization";
import OriginAlliance from "Components/OriginAlliances";
import Appbanner from "Components/Appbanner";
import LiveShows from "Pages/LiveShows";
import FloatingContactIcon from "Components/FloatingContactIcon"

const Home = () => {
  return (
    <>
      <Banner />
      <RJCBanner />
      {/* <AboutSection /> */}
      <OurDiamondCuts />
      <LayoutAndMatchPair />
      {/* <WhyChooseArjiv /> */}
      <Quote />
      <Customization />
      <OriginAlliance />
      <LiveShows />
      <Appbanner />
      <FloatingContactIcon />
    </>
  );
};

export default Home;
